import type { ReactNode } from 'react';
import { hasCommerceCapability, type CommerceCapability } from '../platform/commerceCapabilities';
import { useAuth } from './AuthContext';

/** Client-side direct URL guard. REST remains the authoritative security gate. */
export function RequireCommerceCapability({ capability, children }: { capability: CommerceCapability; children: ReactNode }) {
  const { role } = useAuth();
  if (hasCommerceCapability(role, capability)) return children;
  return (
    <div className="state-block" data-testid="commerce-capability-denied">
      <div className="state-title">無權限</div>
      <div className="text-secondary">此頁需要額外的方案或帳務讀取權限。</div>
    </div>
  );
}

